import React, { useCallback, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import styles from "./myResource.module.scss";
import { useAddResourceMutation, useDeleteResourceMutation, useGetResourceListQuery } from "store/services/resource";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { CommonToolTip, CstmPagination } from "components/Common/Common";
import TableLayout from "components/TableLayout";
import { debounce } from "lodash";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { successMessageToast } from "helpers/common";
import { useLazyGetFileUrlQuery, useUploadFileMutation } from "store/services/utility";
import { MIME_TYPES } from "config/constants";
import { FileIcon2 } from "Assets/icons";
const MyResources = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState({ search: "", sort: { column: "id", direction: "desc" } });
  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);

  const { data, isLoading, isError, isFetching } = useGetResourceListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const [deleteResource, { isLoading: deleteResourceLoading }] = useDeleteResourceMutation();
  const [addResource, { isLoading: AddResourceLoading }] = useAddResourceMutation();

  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();
  const [getFileUrl, { isLoading: getFileLoading }] = useLazyGetFileUrlQuery();

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleFileChange = async (event) => {
    try {
      const file = event.currentTarget.files[0];
      if (file) {

        if (![MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.webp, MIME_TYPES.doc, MIME_TYPES.docx].includes(file.type)) {
          return event.preventDefault();
        }

        const response = await uploadFile({ file, acl: "private" });
        if (response?.error) return;

        const result = await addResource({ attachment_name: response?.data, attachment_key: response?.data });
        if (result?.error) return;

        successMessageToast(result?.data?.message);

      }
    } catch (err) {
      console.error("Error uploading file:", err);
    }
  };

  const handleViewPdf = async (name) => {

    try {
      const result = await getFileUrl(name);
      if (result?.error) return;

      const url = result?.data
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error view pdf", err); }
  };

  const column = [
    {
      head: "File Name",
      accessor: "FileName",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex align-items-center gap-10">
          <div className="content">
            <div className="d-flex align-items-center">
              <div className="position-relative">
                <span className="icn me-1">
                  <FileIcon2
                    width={35}
                    height={35}
                  />
                </span>
                <span style={{
                  position: "absolute",
                  left: "20%",
                  top: "40%",
                  color: "#fff",
                  fontSize: "10px",
                  fontWeight: 700,
                }}>
                  {item?.attachment_key.split(".")[1].toUpperCase()}
                </span>
              </div>
              <h6 className="m-0 fw-bold">{item?.attachment_name || ""}</h6>
            </div>
          </div>
        </div>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center justify-content-md-start justify-content-center w-100  gap-10">

          <CommonToolTip
            text={"View"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => handleViewPdf(item?.attachment_key)}
            >
              <svg style={{ color: "rgb(7, 30, 62)", opacity: "0.6" }} xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
              </svg>
            </Button>}
          />
          <CommonToolTip
            text={"Delete"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => {
                if (!deleteResourceLoading && item?.module == "therapist_resource" && !isFetching) {
                  setCurrentEntry(item);
                  setShowModal(true);
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <circle cx="13.5" cy="13.5" r="13.5" fill="#FFE3E5" />
                <mask
                  id="mask0_26_18856"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="5"
                  y="5"
                  width="18"
                  height="18"
                >
                  <rect x="5" y="5" width="18" height="18" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_26_18856)">
                  <path
                    d="M10.4808 20.3753C10.1068 20.3753 9.78731 20.2429 9.52231 19.978C9.25744 19.713 9.125 19.3935 9.125 19.0195V9.50029H8.375V8.37529H11.75V7.71191H16.25V8.37529H19.625V9.50029H18.875V19.0195C18.875 19.3984 18.7438 19.719 18.4813 19.9815C18.2188 20.244 17.8981 20.3753 17.5192 20.3753H10.4808ZM17.75 9.50029H10.25V19.0195C10.25 19.0869 10.2716 19.1422 10.3149 19.1854C10.3581 19.2287 10.4134 19.2503 10.4808 19.2503H17.5192C17.5769 19.2503 17.6298 19.2262 17.6778 19.1781C17.7259 19.1301 17.75 19.0772 17.75 19.0195V9.50029ZM12.053 17.7503H13.1778V11.0003H12.053V17.7503ZM14.8222 17.7503H15.947V11.0003H14.8222V17.7503Z"
                    fill="#071E3E"
                  />
                </g>
              </svg>
            </Button>}
          />
        </div>
      ),
    },
  ];

  const handleSearch = useCallback(debounce((e) => {

    handleFilterChange("search")(e.target.value);
  }, 500), [handleFilterChange, 500]);

  const handleDelete = async () => {
    try {

      setShowModal(false);

      const result = await deleteResource(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error delete resource", err);
    };
  };

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDelete}
        type="delete"
      />
      <section className="designations position-relative py-4">
        <Container fluid>
          <Col lg="12" className="my-2 border-bottom-1">
            <div className="border-bottom pb-3 d-flex align-items-center justify-content-between gap-10 flex-wrap">
              <div className="left">
                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                  <li className="">
                    <h6 className="m-0 fw-bold themeBlue">Add files</h6>
                  </li>
                  <li className="flex flex-column">
                    <div className={`${styles.upload} position-relative p-3 d-flex align-items-center justify-content-center gap-10 upload`}>
                      <input
                        type="file"
                        placeholder="Choose file here"
                        className="position-absolute h-100 w-100 file"
                        style={{ height: 40, padding: "0 30px" }}
                        accept=".pdf, .jpg, .jpeg, .doc, .docx"
                        onChange={handleFileChange}
                      />

                      <h6 className="m-0 themeClr fw-bold">Choose File</h6>
                      <span className="icn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                          <path d="M18.1913 8.78427C17.8672 7.48854 17.1194 6.33825 16.0668 5.51605C15.0142 4.69385 13.7171 4.24687 12.3815 4.24609C11.0458 4.24532 9.74817 4.69079 8.69462 5.51177C7.64106 6.33275 6.89198 7.48217 6.56633 8.77752C5.0302 8.92168 3.60865 9.65206 2.59695 10.8169C1.58525 11.9818 1.06117 13.4916 1.13357 15.0328C1.20597 16.574 1.86929 18.0281 2.98574 19.093C4.10218 20.1579 5.58595 20.7518 7.12883 20.7513H9.37883C9.57774 20.7513 9.76851 20.6723 9.90916 20.5316C10.0498 20.3909 10.1288 20.2002 10.1288 20.0013C10.1288 19.8024 10.0498 19.6116 9.90916 19.4709C9.76851 19.3303 9.57774 19.2513 9.37883 19.2513H7.12883C6.53788 19.253 5.95238 19.1383 5.40575 18.9138C4.85913 18.6892 4.36209 18.3592 3.943 17.9425C3.09663 17.1011 2.61918 15.9579 2.6157 14.7644C2.61222 13.5709 3.08299 12.4249 3.92444 11.5786C4.76589 10.7322 5.9091 10.2548 7.10258 10.2513C7.29502 10.2658 7.48599 10.2082 7.63843 10.0899C7.79086 9.97155 7.89391 9.8008 7.92758 9.61077C8.0803 8.53982 8.61426 7.55991 9.43142 6.85102C10.2486 6.14213 11.294 5.75184 12.3758 5.75184C13.4576 5.75184 14.5031 6.14213 15.3202 6.85102C16.1374 7.55991 16.6714 8.53982 16.8241 9.61077C16.8633 9.7942 16.965 9.95833 17.1117 10.0751C17.2585 10.1919 17.4413 10.2542 17.6288 10.2513C18.8223 10.2513 19.9669 10.7254 20.8108 11.5693C21.6547 12.4132 22.1288 13.5578 22.1288 14.7513C22.1288 15.9447 21.6547 17.0893 20.8108 17.9333C19.9669 18.7772 18.8223 19.2513 17.6288 19.2513H15.3788C15.1799 19.2513 14.9891 19.3303 14.8485 19.4709C14.7078 19.6116 14.6288 19.8024 14.6288 20.0013C14.6288 20.2002 14.7078 20.3909 14.8485 20.5316C14.9891 20.6723 15.1799 20.7513 15.3788 20.7513H17.6288C19.1604 20.7352 20.6279 20.1341 21.7305 19.071C22.8332 18.0079 23.4875 16.5633 23.5594 15.0333C23.6313 13.5033 23.1154 12.0038 22.1173 10.8419C21.1193 9.68006 19.7147 8.94389 18.1913 8.78427Z" fill="#B46C9F" />
                          <path d="M15.5982 15.2801C15.7397 15.4167 15.9291 15.4923 16.1258 15.4906C16.3224 15.4889 16.5105 15.41 16.6496 15.271C16.7886 15.1319 16.8675 14.9438 16.8692 14.7471C16.8709 14.5505 16.7953 14.361 16.6587 14.2196L12.9087 10.4696C12.7681 10.329 12.5774 10.25 12.3785 10.25C12.1796 10.25 11.9889 10.329 11.8482 10.4696L8.09823 14.2196C7.96161 14.361 7.88601 14.5505 7.88772 14.7471C7.88943 14.9438 7.96831 15.1319 8.10737 15.271C8.24642 15.41 8.43453 15.4889 8.63118 15.4906C8.82783 15.4923 9.01728 15.4167 9.15873 15.2801L11.6285 12.8103V22.2498C11.6285 22.4488 11.7075 22.6395 11.8481 22.7802C11.9888 22.9208 12.1796 22.9998 12.3785 22.9998C12.5774 22.9998 12.7682 22.9208 12.9088 22.7802C13.0495 22.6395 13.1285 22.4488 13.1285 22.2498V12.8103L15.5982 15.2801Z" fill="#B46C9F" />
                        </svg>
                      </span>
                    </div>
                    <i
                      className="m-0 d-flex flex-wrap mt-2 text-bold justify-content-center
                    "
                      style={{ fontSize: "12px" }}
                    >
                      Please upload only .pdf, jpg, png and word doc
                    </i>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <h6 className="m-0 fw-bold themeBlue">My Resources</h6>
                    </li>
                  </ul>
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <Form>
                        <div className="iconWithText position-relative ">
                          <span
                            className="icn position-absolute"
                            style={{ left: 10 }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M14.2621 15.5742L9.27139 10.8848C8.81306 11.2632 8.28598 11.5594 7.69014 11.7733C7.09431 11.9872 6.47793 12.0941 5.841 12.0941C4.27426 12.0941 2.9483 11.5517 1.86312 10.4668C0.777942 9.38192 0.235352 8.05626 0.235352 6.48983C0.235352 4.92356 0.777789 3.59744 1.86266 2.5115C2.94754 1.42571 4.27319 0.882812 5.83962 0.882812C7.4059 0.882812 8.73201 1.4254 9.81796 2.51058C10.9037 3.59576 11.4466 4.92172 11.4466 6.48846C11.4466 7.14311 11.3368 7.76835 11.1171 8.36419C10.8973 8.96002 10.604 9.47824 10.2373 9.91886L15.228 14.608L14.2621 15.5742ZM5.841 10.7193C7.02212 10.7193 8.02251 10.3094 8.84216 9.48962C9.66197 8.66997 10.0719 7.66958 10.0719 6.48846C10.0719 5.30733 9.66197 4.30694 8.84216 3.48729C8.02251 2.66749 7.02212 2.25758 5.841 2.25758C4.65987 2.25758 3.65948 2.66749 2.83983 3.48729C2.02003 4.30694 1.61012 5.30733 1.61012 6.48846C1.61012 7.66958 2.02003 8.66997 2.83983 9.48962C3.65948 10.3094 4.65987 10.7193 5.841 10.7193Z"
                                fill="#1C1B1F"
                              />
                            </svg>
                          </span>
                          <span
                            className="icn position-absolute"
                            style={{ right: 10 }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <g opacity="0.5">
                                <path
                                  d="M10.33 16.593H4.0293"
                                  stroke="#071E3E"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M13.1406 6.89969H19.4413"
                                  stroke="#071E3E"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M8.72629 6.84625C8.72629 5.5506 7.66813 4.5 6.36314 4.5C5.05816 4.5 4 5.5506 4 6.84625C4 8.14191 5.05816 9.19251 6.36314 9.19251C7.66813 9.19251 8.72629 8.14191 8.72629 6.84625Z"
                                  stroke="#071E3E"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M19.9997 16.5533C19.9997 15.2576 18.9424 14.207 17.6374 14.207C16.3316 14.207 15.2734 15.2576 15.2734 16.5533C15.2734 17.8489 16.3316 18.8995 17.6374 18.8995C18.9424 18.8995 19.9997 17.8489 19.9997 16.5533Z"
                                  stroke="#071E3E"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                            </svg>
                          </span>
                          <input
                            type="text"
                            placeholder="Search..."
                            className="form-control"
                            style={{ height: 40, padding: "0 30px" }}
                            onChange={handleSearch}
                          />
                        </div>
                      </Form>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || deleteResourceLoading || isUploading || AddResourceLoading || getFileLoading) && <LoadingOverlay />}
                    <TableLayout
                      data={data?.records || []}
                      column={column}
                      handleSort={handleFilterChange("sort")}
                      filter={filter}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default MyResources;
